<template>
  <app-base-main
      no-padding
      :table-shadow="false"
  >
    <template #filter-group>
      <app-filter-group
          :reset="false"
          @query="$gjNoticeQuery">
        <gj-market-select
            initValue
            adMarket
            :clearable="false"
            v-model="filter.marketIds"
            :multiple="true"
            placeholder="全部店铺"
            width="160px"
        ></gj-market-select>
        <gj-select
            v-model="filter.objectType"
            :options="option.objectTypeOption"
            placeholder="类型"
            style="margin-right: 8px"
        ></gj-select>
        <gj-select
            v-model="filter.adsStatus"
            :options="option.adStatusOption"
            placeholder="广告状态"
            style="margin: 0"
        ></gj-select>
        <gj-select
            v-model="filter.status"
            :options="option.policyStatusOption"
            placeholder="策略状态"
        ></gj-select>
        <gj-input
            v-model="filter.keyword"
            placeholder="对象名称"
            width="150px"
        ></gj-input>
        <template #right>
          <gj-help style="margin-left: 8px;">
            说明：<br>
            策略状态：按活动活动/广告组添加的策略，广告活动/广告组的策略是“停用”，关联的应用明细的策略状态为“开启中”也不会生效<br>
            移除策略：如移除的是广告活动/广告组，会将关联的应用明细里的子集分时策略全部移除<br>
            停用策略：如停用的是广告活动/广告组，只会停用掉选择的对象的状态，关联的应用明细的策略状态不会改变<br>
          </gj-help>
        </template>
      </app-filter-group>
    </template>
    <template #operate-group>
      <gj-button type="primary" @click="$emit('pause',selectedRows)">暂停</gj-button>
      <gj-button @click="$emit('delete',selectedRows)">移除</gj-button>
      <gj-button @click="$emit('enable',selectedRows)">开启</gj-button>
    </template>
    <template #table>
      <div style="height: 500px">
        <gj-table
            ref="gjTable"
            :index="false"
            :loading="loading"
            :data="tableData"
            :columns="columns"
            adaptParent
            :selection="true"
            :pagination="pagination"
            @page-change="$gjNoticeQuery">

          <!--          活跃状态-->
          <template v-slot:adsStatus="{row}">
            {{ row.adsStatus | optionText(option.adStatusOption) | defaultShow }}
            <!--            广告活动和广告位 没有下级 不显示-->
            <gj-tooltip>
              <i class="el-icon-arrow-down"></i>
              <template #content>

<!--&lt;!&ndash;                广告组&ndash;&gt;-->
<!--                <template v-if="row.objectType === 1">-->
<!--                  <div>广告活动状态： {{ row.campaignState | optionText(AdCampaignEnum.SP.statusOption) | defaultShow }}</div>-->
<!--                  <div>广告组状态： {{ row.state | optionText(AdCampaignEnum.SP.statusOption) | defaultShow }}</div>-->
<!--                </template>-->

<!--&lt;!&ndash;                关键词、商品投放、投放组&ndash;&gt;-->
<!--                <template v-if="[3,4,5].includes(row.objectType)">-->
                  <div>广告活动状态： {{ row.campaignState | optionText(AdCampaignEnum.SP.statusOption) | defaultShow }}</div>
                  <div v-if="[1,3,4,5].includes(row.objectType)">广告组状态： {{ row.groupState | optionText(AdCampaignEnum.SP.statusOption) | defaultShow }}</div>
                  <div v-if="[3,4,5].includes(row.objectType)">投放状态： {{ row.state | optionText(AdCampaignEnum.SP.statusOption) | defaultShow }}</div>
<!--                </template>-->

              </template>
            </gj-tooltip>
          </template>

          <!--          开关-->
          <template v-slot:status="{row}">
            <template v-if="$permission('adsStrategyObject:delete')">
              <gj-switch
                  size="small"
                  :value="row.status === AdStrategyEnum.status.object.ENABLE"
                  @input="switchStatus($event, row)">
              </gj-switch>
            </template>
            <template v-else>
              {{ row.status | optionText(AdStrategyEnum.statusOption.object) | defaultShow }}
            </template>
          </template>

          <template v-slot:op="{row}">
            <gj-button
                type="text"
                @click="$emit('delete',[row])">移除
            </gj-button>
            <gj-button
                v-if="row.objectType===0||row.objectType===1"
                type="text"
                @click="lookDetailed(row)"
            >对象明细
            </gj-button>
          </template>
        </gj-table>
      </div>

    </template>
  </app-base-main>
</template>

<script>
import {isMeaninglessMixin, queryMixin, selectionMixin} from "@/minxins";
import {AdCampaignEnum, AdPlacementEnum, AdTargetEnum} from "@/views/modules/ad/common/enum";
import {defaultVal} from "@/utils/common";
import {AdStrategyEnum} from "@/views/modules/ad/strategy/common/enum";
import {mapGetters} from "vuex";
import {
  getAdsAdjustStrategyUsePage,
} from "@/api/ad";

export default {
  name: "detail-content",
  mixins: [queryMixin, isMeaninglessMixin, selectionMixin],
  props: {
    item: {
      required: true
    }
  },
  data() {
    return {
      AdCampaignEnum,
      tableData: [],
      columns: [
        {id: 'marketId', header: '站点', field: 'option:marketId', minWidth: '80px', options: () => this.marketOption},
        {
          id: 'objectName', header: '对象', field: 'option:objectName', minWidth: '160px',
          options: [
            ...AdPlacementEnum.SP.strategyPlacementOption,
            ...AdTargetEnum.SP.targetTypeOption
          ],
          defaultShow: (row) => {
            return defaultVal(row.objectName, '-');
          }
        },
        {
          id: 'objectType',
          header: '类型',
          field: 'option:objectType',
          options: AdStrategyEnum.objectTypeOption,
          width: '80px'
        },
        {id: 'campaignName', header: '广告活动', field: 'campaignName', minWidth: '200px'},
        {id: 'groupName', header: '广告组', field: 'groupName', minWidth: '150px'},
        {
          id: 'adsStatus',
          header: '活跃状态',
          field: 'slot:adsStatus',
          width: '90px',
          help: '自己及所属广告活动、广告组都为启用中的才是活跃，有一个暂停或归档的都为不活跃'
        },
        // {
        //   id: 'parentStatus',
        //   header: '策略状态',
        //   field: 'option:parentStatus',
        //   width: '80px',
        //   options: AdCampaignEnum.SP.statusOption
        // },
        {id: 'status', header: '开启', field: 'slot:status', width: '60px'},
        {
          id: 'op',
          header: '操作',
          field: 'slot:op',
          width: '120px',
          permission: 'adsStrategyObject:delete',
          notCustomColumn: true
        },
      ],
      filter: {
        marketIds: [],// 已选中的店铺
        objectType: null,// 类型
        adsStatus: null,// 广告状态
        status: null,// 策略状态
        keyword: null,// 对象名称
      },
      option: {
        objectTypeOption: AdStrategyEnum.objectTypeOption,
        adStatusOption: AdStrategyEnum.adStatusOption,
        policyStatusOption: AdStrategyEnum.policyStatusOption
      },
      AdStrategyEnum: AdStrategyEnum,
      updated: false
    }
  },
  computed: {
    ...mapGetters({
      marketOption: 'marketOption'
    }),
  },
  // created() {
  //   this.filter.marketIds = this.marketOption.map(r => r.id.toString());
  // },
  methods: {
    // 查看明细
    lookDetailed(row)  {
      let name = AdTargetEnum.SP.targetTypeOption.find(r => r.id === row.objectName)?.text
          || AdPlacementEnum.SP.strategyPlacementOption.find(r => r.id === row.objectName)?.text
          || row.objectName
          || '-';
      this.$emit('lookDetailed', {
        text: name + '明细',
        detailedItem: {
          parentObjectId: row.parentObjectId,
          objectType: row.objectType,
          marketId: row.marketId
        }
      })
    },
    $gjQuery() {
      // 构造查询参数
      const params = {
        model: {
          templateId: this.item.id,// 模板id
          marketIds: this.filter.marketIds,// 站点id集合
          objectType: defaultVal(this.filter.objectType, null),// 类型 (0：广告活动，1：广告组，2：广告位，3：关键词，4：商品投放，5：投放组)（查询子集）
          adsStatus: this.filter.adsStatus,// 广告状态
          status: this.filter.status,// 策略状态
          objectName: this.filter.keyword,// 输入框
        },
        ...this.queryPagination,
        ...this.querySort
      };
      // 查询
      this.loading = true;
      getAdsAdjustStrategyUsePage(params)
          .then((data) => {
            this.tableData = (data.records || []);
            this.pagination = this.getPagination(data);
          })
          .complete(() => this.loading = false);
    },
    // 开关变化回调
    switchStatus(open, row) {
      if (open) {
        this.$emit('enable',[row])
        // this.enable([row]);
      } else {
        this.$emit('pause',[row])
        // this.pause([row]);
      }
    },

  }
}
</script>

<style scoped lang="scss">
/deep/ .filter-group {
  .el-row--flex.is-justify-space-between {
    justify-content: left;
  }
}
</style>